





































































































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Title from '../../components/Title.vue';
import { Message } from 'element-ui';
import { 
  UserListParams, 
  UserListRes, 
  UserListData,
  Roles,
  Role,
  Table,
  recogniseDosUserData,
  FormLabelAlign,
  CommonRes,
} from '@/store/pages/authority/index.d';
import { ReportList } from '@/store/pages/report/index.d';
const Report = namespace('report');
const Authority = namespace('authority');
@Component({
  components: {
    Title,
  },
})
export default class Index extends Vue {
  @Authority.Getter('userList') private userList!: UserListData;
  @Authority.Getter('roleList') private roleList!: Role[];
  @Authority.Getter('dosUser') private dosUser!: recogniseDosUserData;
  @Authority.Getter('errorInfo') private errorInfo!: string;
  @Authority.Getter('disabled') private disabled!: boolean;
  @Report.Getter('reportList') private reportList!: ReportList[];

  @Authority.Action('getUserList') private getUserList: any;
  @Authority.Action('getRoleList') private getRoleList: any;
  @Report.Action('getReportList') private getReportList: any;
  @Authority.Action('changeAccountStatus') private changeAccountStatus: any;
  @Authority.Action('saveModifyRoles') private saveModifyRoles: any;
  @Authority.Action('recogniseDosUser') private recogniseDosUser: any;
  @Authority.Action('saveNewUser') private saveNewUser: any;
  @Authority.Mutation('update_dos_user') private UPDATE_DOS_USER: any;
  @Authority.Mutation('update_error_info') private UPDATE_ERROR_INFO: any;
  @Authority.Mutation('update_disabled') private UPDATE_DISABLED: any;
  private title: string[] = ['账号管理'];
  private dialogDeleteTableVisible: boolean = false;
  private dialogDetailTableVisible: boolean = false;
  private dialogEditorTableVisible: boolean = false;
  private dialogNewTableVisible: boolean = false;
  private confirmStyle: boolean = false;
  private loading: boolean = true;
  private labelPosition: string = 'right';
  private userId: number = 0;
  private revesStatus: number = 0;
  private mobileNum: string = '';
  private previous: string = '';
  private tips: string = '账号禁用后，用户不可再登录系统。您还要继续吗？';
  private checkList: string[] = [];
  private formLabelAlign: FormLabelAlign = {
    name: '',
    region: '',
    type: '',
  };
  private requestParams: UserListParams = {
    page: 1,
    count: 10,
    sort_order: 0,
  };

  public mounted() {
    this.getData();
    this.getRoleList();
  }
  public getData() {
    this.loading = true;
    this.getUserList(this.requestParams).then((res: UserListRes) => {
      this.loading = false;
    });
  }
  public sortChange(params: any) {
    const {order} = params;
    this.requestParams.sort_order = order === 'ascending' ? 1 : 0;
    this.getData();
  }
  public handleSizeChange(val: number) {
    this.requestParams.count = val;
    this.requestParams.page = 1;
    this.getData();
  }
  public handleCurrentChange(val: number) {
    this.requestParams.page = val;
    this.getData();
  }
  public createNewUser(val: number) {
    this.mobileNum = '';
    this.UPDATE_DISABLED(true);
    this.dialogNewTableVisible = true;
    this.UPDATE_ERROR_INFO('');
    this.UPDATE_DOS_USER({});
  }
  public search() {
    if (this.mobileNum === '') {
      Message.error('手机号码不能为空');
    } else if (this.mobileNum.length !== 11) {
      Message.error('手机号码必须为11位');
    } else {
      this.recogniseDosUser({mobile_number: this.mobileNum});
    }
  }
  public close() {
    this.dialogNewTableVisible = false;
  }
  public saveNew() {
    this.dialogNewTableVisible = false;
    this.saveNewUser({dos_user_id: this.dosUser.dos_user_id}).then((res: any) => {
      this.getData();
    });
  }
  public changeStatus(row: any) {
    this.dialogDeleteTableVisible = true;
    const { user_id, status } = row;
    this.tips = status === 1 ? '账号禁用后，用户不可再登录系统。您还要继续吗？' : '账号启用后，用户可以登录系统。您还要继续吗？'
    this.confirmStyle = status === 2 ? true : false;
    this.userId = user_id;
    this.revesStatus = status === 1 ? 2 : 1;
  }
  public confirm() {
    this.dialogDeleteTableVisible = false;
    this.changeAccountStatus({user_id: this.userId, status: this.revesStatus}).then((res: any) => {
      this.getData();
    });
  }
  public modifyRole(id: number) {
    this.userId = id;
    this.checkList = [];
    const users: any = this.userList.table.find((user: Table) => {
      return user.user_id === id;
    }); 
    users.roles.forEach((item: Roles) => {
      this.checkList.push(item.name);
    });
    this.dialogEditorTableVisible = true;
  }
  public save() {
    this.dialogEditorTableVisible = false;
    const roles: string[] = [];
    this.roleList.forEach((role: Role) => {
      this.checkList.forEach((item: string) => {
        if (item === role.name) {
          roles.push(role.id.toString());
        }
      })
    });
    this.saveModifyRoles({userId: this.userId, roles}).then((res: CommonRes) => {
      this.getData();
    });
  }
  public showAvailableReport(userId: number) {
    this.dialogDetailTableVisible = true;
    this.getReportList({user_id: userId});
  }
  public verifyMobileNum() {
    this.$nextTick(() => {
      if (this.previous === '') {
        this.mobileNum = /\d/.test(this.mobileNum) ? this.mobileNum : '';
      } else if (this.previous.length === 11) {
        this.mobileNum = this.mobileNum.length <= 11 ? this.mobileNum : this.previous;
      } else {
        if (this.mobileNum === '') {
          this.mobileNum = '';
        } else {
          const newLetter = this.mobileNum[this.mobileNum.length - 1];
          this.mobileNum = /\d/.test(newLetter) ? this.mobileNum : this.previous;
        }
      }
      this.previous = this.mobileNum;
    })
  }
}
